// extracted by mini-css-extract-plugin
module.exports = {"team-grid__header":"_5D1UTZ7n","scroll-list":"_5D3JkGRj","thumb":"_5D1PCwYx"};